import React, { useState, useEffect, useContext } from "react";
import { useParams } from 'react-router-dom';
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import "../AdminDashboard.css";
import MyContext from "../../../MyContext";
import Download from "../../../images/Dowload Admin.png"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaMoneyBillWave, FaFileInvoiceDollar, FaCommentsDollar, FaCommentDots, FaCoins, FaReceipt, FaWallet, FaUtensils } from 'react-icons/fa';
import { CheckCircle, Clock, ShoppingCart, AlertCircle } from 'lucide-react';
import NoIndex from "../../NoIndex";
function AdminSettlementAnalytics() {
    const { baseUrl } = useContext(MyContext);
    const { config } = useContext(MyContext);
    const { clientId } = useParams();
    const { clientName } = useParams();
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const [Analytics, setAnalytics] = useState([]);
    const [Report, setReport] = useState([]);
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split("T")[0]; // Format: 'YYYY-MM-DD'
    };

    const [fromDate, setFromDate] = useState(getCurrentDate());
    const [toDate, setToDate] = useState(getCurrentDate());
    const [Amount, setAmount] = useState('');
    const [History, setHistory] = useState([]);
    const [searchQueryHistory, setSearchQueryHistory] = useState("");
    const [currentPageHistory, setCurrentPageHistory] = useState(1);



    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 100;

    const FetchSettlementAnalytics = async () => {
        setLoading(true);
        try {
            const UserDetail = { userid: clientId, fromDate, toDate };
            const response = await axios.post(
                `${baseUrl}/api/Transactions/v1.0/getTransactionsAnalytics`,
                UserDetail,
                config
            );
            if (response.data.responseCode === "00") {
                setAnalytics(response.data.response);
            } else {
                toast.error(response.data.responseMessage);
                setAnalytics([]);
            }
        } catch (error) {
            toast.error("Error fetching analytics.");
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const FetchSettlementReport = async () => {
        setLoading(true);
        try {
            const UserDetail = { userid: clientId, fromDate, toDate };
            const response = await axios.post(
                `${baseUrl}/api/Admin/v1.0/getSettlementReport`,
                UserDetail,
                config
            );
            if (response.data.responseCode === "00") {
                setReport(response.data.response);
            } else {
                toast.error(response.data.responseMessage);
                setReport([]);
            }
        } catch (error) {
            toast.error("Error fetching settlement report.");
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };
    const FetchProcessedHistory = async () => {
        setLoading(true);
        try {
            const UserDetail = { userid: clientId, fromDate, toDate }; // same filter
            const response = await axios.post(
                `${baseUrl}/api/Admin/v1.0/getProcessedSettlements`,
                UserDetail,
                config
            );
            if (response.data.responseCode === "00") {
                setHistory(response.data.response);
            } else {
                toast.error(response.data.responseMessage);
                setHistory([]);
            }
        } catch (error) {
            toast.error("Error fetching history data.");
            console.error("Fetch History Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (Analytics?.totalSettlementAmount) {
            setAmount(parseFloat(Analytics.totalSettlementAmount));
        }
    }, [Analytics]);
    const handleProcessSettlement = async () => {
        // Show SweetAlert for confirmation
        const result = await Swal.fire({
            title: `Confirm Settlement Processing of ${clientName}`,
            html: `
            <b>Start Date:</b> ${fromDate}<br/>
            <b>End Date:</b> ${toDate}<br/><br/>
            <b>Amount:</b> ${Amount}<br/><br/>
            Are you sure you want to process settlements for this date range?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Process it!",
            cancelButtonText: "Cancel",
        });

        // If user confirmed
        if (result.isConfirmed) {
            setLoading(true);
            try {
                const UserDetail = { userid: clientId, fromDate, toDate };
                const response = await axios.post(
                    `${baseUrl}/api/Admin/v1.0/processSettlement`,
                    UserDetail,
                    config
                );

                if (response.data.responseCode === "00") {
                    Swal.fire("Success", "Settlement Processed Successfully!", "success");
                    // If you want, refresh data
                    FetchSettlementAnalytics();
                } else {
                    toast.error(response.data.responseMessage);
                }
            } catch (error) {
                toast.error("Error processing settlement.");
                console.error("Process Settlement Error:", error);
            } finally {
                setLoading(false);
            }
        }
    };


    useEffect(() => {
        if (clientId) {
            // FetchSettlementAnalytics();
            FetchSettlementReport();
            FetchProcessedHistory();
        }
    }, [clientId]);

    const handleFilter = () => {
        if (new Date(fromDate) > new Date(toDate)) {
            Swal.fire("Error", "From Date cannot be after To Date.", "error");
            return;
        }
        FetchSettlementAnalytics();
        FetchSettlementReport();
    };

    const downloadExcel = () => {
        if (Report.length === 0) {
            toast.error("No report data to download.");
            return;
        }
        const worksheet = XLSX.utils.json_to_sheet(Report);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "SettlementReport");
        const excelBuffer = XLSX.write(workbook, { type: "array", bookType: "xlsx" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, `SettlementReport_${clientId}.xlsx`);
    };
    const downloadHistoryExcel = () => {
        if (History.length === 0) {
            toast.error("No history data to download.");
            return;
        }
        const worksheet = XLSX.utils.json_to_sheet(History);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ProcessedHistory");
        const excelBuffer = XLSX.write(workbook, { type: "array", bookType: "xlsx" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, `ProcessedHistory_${clientId}.xlsx`);
    };

    // Filter Report based on search query first
    const filteredReport = Report.filter((item) => {
        const searchStr = searchQuery.toLowerCase();
        return (
            (item.datetime || "").toLowerCase().includes(searchStr) ||
            (item.customer_name || "").toLowerCase().includes(searchStr) ||
            (item.customer_mobile || "").toLowerCase().includes(searchStr) ||
            (item.refrence || "").toLowerCase().includes(searchStr) ||
            (item.payment_mode || "").toLowerCase().includes(searchStr) ||
            (item.settlement_status || "").toLowerCase().includes(searchStr) ||
            (item.category || "").toLowerCase().includes(searchStr)
        );
    });

    // Pagination after search
    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
    const currentEntries = filteredReport.slice(indexOfFirstEntry, indexOfLastEntry);
    const totalPages = Math.ceil(filteredReport.length / entriesPerPage);

    const cards = Analytics && Object.keys(Analytics).length !== 0 ? [
        { label: "Total Order Amount", value: `₹${parseFloat(Analytics.totalOrderAmount || 0).toFixed(2)}`, icon: <FaMoneyBillWave /> },
        { label: "Total Platform Charges", value: `₹${parseFloat(Analytics.totalPlatformCharges || 0).toFixed(2)}`, icon: <FaFileInvoiceDollar /> },
        { label: "Total Message Charges", value: `₹${parseFloat(Analytics.totalMessageCharges || 0).toFixed(2)}`, icon: <FaCommentsDollar /> },
        { label: "Total Messages Sent", value: Analytics.totalMessages || 0, icon: <FaCommentDots /> },
        { label: "Per Message Cost", value: `₹${parseFloat(Analytics.perMessageCost || 0).toFixed(2)}`, icon: <FaCoins /> },
        { label: "Total Gateway Charges", value: `₹${parseFloat(Analytics.totalGatewayCharges || 0).toFixed(2)}`, icon: <FaReceipt /> },
        { label: "Total Settlement Amount", value: `₹${parseFloat(Analytics.totalSettlementAmount || 0).toFixed(2)}`, icon: <FaWallet /> },
    ] : [];
    const filteredHistory = History.filter((item) => {
        const searchStr = searchQueryHistory.toLowerCase();
        return (
            (item.datetime || "").toLowerCase().includes(searchStr) ||
            (item.customer_name || "").toLowerCase().includes(searchStr) ||
            (item.customer_mobile || "").toLowerCase().includes(searchStr) ||
            (item.refrence || "").toLowerCase().includes(searchStr) ||
            (item.payment_mode || "").toLowerCase().includes(searchStr) ||
            (item.settlement_status || "").toLowerCase().includes(searchStr) ||
            (item.category || "").toLowerCase().includes(searchStr)
        );
    });

    const indexOfLastEntryHistory = currentPageHistory * entriesPerPage;
    const indexOfFirstEntryHistory = indexOfLastEntryHistory - entriesPerPage;
    const currentEntriesHistory = filteredHistory.slice(indexOfFirstEntryHistory, indexOfLastEntryHistory);
    const totalPagesHistory = Math.ceil(filteredHistory.length / entriesPerPage);
    function StatusBadgeSettlement({ status }) {
        const isSettled = status === 'Y';

        const styles = {
            display: 'inline-flex',
            alignItems: 'center',
            padding: '4px 10px',
            borderRadius: '999px',
            fontSize: '0.85rem',
            fontWeight: '600',
            backgroundColor: isSettled ? '#e6f4ea' : '#fff4e5',
            color: isSettled ? '#2e7d32' : '#b26a00',
            border: `1px solid ${isSettled ? '#c8e6c9' : '#ffe0b2'}`,
            gap: '6px'
        };

        return (
            <span style={styles}>
                {isSettled ? <CheckCircle size={16} /> : <Clock size={16} />}
                {isSettled ? 'Settled' : 'Pending'}
            </span>
        );
    }
    function CategoryBadge({ category }) {
        const isOrder = category === 'order';

        const styles = {
            display: 'inline-flex',
            alignItems: 'center',
            padding: '4px 10px',
            borderRadius: '999px',
            fontSize: '0.85rem',
            fontWeight: '600',
            backgroundColor: isOrder ? '#e3f2fd' : '#fdecea',
            color: isOrder ? '#1565c0' : '#c62828',
            border: `1px solid ${isOrder ? '#bbdefb' : '#f8bbd0'}`,
            gap: '6px'
        };

        return (
            <span style={styles}>
                {isOrder ? <ShoppingCart size={16} /> : <AlertCircle size={16} />}
                {isOrder ? 'Order' : 'Incomplete Order'}
            </span>
        );
    }




    return (
        <div className="marginRight admin-settlement-main" style={{ minHeight: "100vh" }}>  <NoIndex />
            <div className="admin-settlement-container py-3 mx-2">
                <h2 className="admin-settlement-heading mb-5 text-start">Settlement Analytics of {clientName}  <FaUtensils size={30} color="#333" /></h2>

                {/* Filter Section */}
                <div className="admin-settlement-filter row mb-4 justify-content-start">
                    <div className="col-md-3 mb-2">
                        <input
                            type="date"
                            className="form-control"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>
                    <div className="col-md-3 mb-2">
                        <input
                            type="date"
                            className="form-control"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>

                    {/* Buttons */}
                    <div className="col-md-3 mb-2 d-flex gap-2">
                        <button className="btn btn-sm btn-primary w-50" onClick={handleFilter}>
                            Filter
                        </button>
                        <button className="btn btn-sm btn-success w-50" onClick={handleProcessSettlement}>
                            Process Settlement
                        </button>
                    </div>
                </div>


                <hr />


                {/* Analytics Cards */}
                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : cards.length === 0 ? (
                    <div className="text-center py-5">
                        <p>No analytics data available.</p>
                    </div>
                ) : (
                    <div className="admin-settlement-cards-custom-grid">
                        {/* Big Card Left */}
                        <div className="admin-settlement-card-big">
                            <div className="d-flex">

                                <h3>  Messaging Summary</h3></div>
                            <hr />

                            <div className="admin-settlement-card-details">
                                <table className=" rounded-1" style={{ borderCollapse: 'collapse', width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '8px', }}><b>Per Message Cost:</b></td>
                                            <td className="text-end" style={{ padding: '8px', }}>
                                                ₹{parseFloat(Analytics.perMessageCost || 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px', }}><b>Total Messages:</b></td>
                                            <td className="text-end" style={{ padding: '8px', }}>
                                                {Analytics.totalMessages || 0}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '8px', }}><b>Total Message Charges:</b></td>
                                            <td className="text-end" style={{ padding: '8px', }}>
                                                ₹{parseFloat(Analytics.totalMessageCharges || 0).toFixed(2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                        {/* Small Card 1 */}
                        <div className="admin-settlement-card-small" style={{ border: "2px solid #01C27D", backgroundColor: "rgba(1, 194, 126, 0.03)" }}>
                            <div>    <h6>Total Order Amount</h6>
                                <p>₹{parseFloat(Analytics.totalOrderAmount || 0).toFixed(2)}</p></div>

                            <div className="admin-settlement-card-icon" style={{ backgroundColor: "#D3F3DF", borderRadius: "50%", height: "2.5rem", width: "2.5rem", display: "flex", alignItems: "center", justifyContent: "center", color: "green" }}>
                                <FaMoneyBillWave />
                            </div>
                        </div>

                        {/* Small Card 2 */}
                        <div className="admin-settlement-card-small" style={{ border: "2px solid #8252E9", backgroundColor: "rgba(130, 82, 233, 0.03)" }}>
                            <div> <h6>Platform Charges</h6>
                                <p>₹{parseFloat(Analytics.totalPlatformCharges || 0).toFixed(2)}</p></div>

                            <div className="admin-settlement-card-icon" style={{ backgroundColor: "#E8DEFF", borderRadius: "50%", height: "2.5rem", width: "2.5rem", display: "flex", alignItems: "center", justifyContent: "center", color: "purple" }}>
                                <FaFileInvoiceDollar />
                            </div>
                        </div>

                        {/* Small Card 3 */}
                        <div className="admin-settlement-card-small" style={{ border: "2px solid #FF8D00", backgroundColor: "rgba(255, 140, 0, 0.03)" }}>
                            <div><h6>Gateway Charges</h6>
                                <p>₹{parseFloat(Analytics.totalGatewayCharges || 0).toFixed(2)}</p></div>

                            <div className="admin-settlement-card-icon" style={{ backgroundColor: "#FBDBB2", borderRadius: "50%", height: "2.5rem", width: "2.5rem", display: "flex", alignItems: "center", justifyContent: "center", color: "orange" }}>
                                <FaReceipt />
                            </div>
                        </div>

                        {/* Small Card 4 */}
                        <div className="admin-settlement-card-small" style={{ border: "2px solid #467EFF", backgroundColor: "rgba(70, 126, 255, 0.03)", color: "" }}>
                            <div><h6>Total Settlement Amount</h6>
                                <p>₹{parseFloat(Analytics.totalSettlementAmount || 0).toFixed(2)}</p></div>
                            <div className="admin-settlement-card-icon" style={{ backgroundColor: "#DDE7FF", borderRadius: "50%", height: "2.5rem", width: "2.5rem", display: "flex", alignItems: "center", justifyContent: "center", color: "blue" }}>
                                <FaWallet />
                            </div>
                        </div>
                    </div>



                )}

                {/* Tabs Section */}
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Settlement Report</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Settlement History</button>
                    </li>


                </ul>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0"> {/* Settlement Report Table */}
                        <div className="mt-5">
                            {/* Heading And Filter section of table */}
                            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                                <h3 className="admin-settlement-heading mb-2">Settlement Report</h3>

                                <div className="d-flex gap-2 mb-2 ms-auto me-1 mt-1">
                                    <input
                                        type="text"
                                        className="form-control form-sm"
                                        placeholder="Search..."
                                        style={{ minWidth: "200px" }}
                                        value={searchQuery}
                                        onChange={(e) => {
                                            setSearchQuery(e.target.value);
                                            setCurrentPage(1); // Reset to page 1 on new search
                                        }}
                                    />
                                </div>
                                <button onClick={downloadExcel} className="btn btn-success">
                                    <img src={Download} alt="" /> Download Excel
                                </button>
                            </div>

                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : Report.length === 0 ? (
                                <div className="text-center py-5">
                                    <p>No report data available.</p>
                                </div>
                            ) : (
                                <>
                                    <div className="scrollable-table border-radius-10-left">
                                        <table className="table table-bordered table-hover">
                                            <thead className="text-center   py-4">
                                                <tr className="text-center   py-4">
                                                    <th
                                                        className="pb-3 th-style">Date/Time</th>
                                                    <th className="pb-3 th-style">Customer Name</th>
                                                    <th className="pb-3 th-style">Customer Mobile</th>
                                                    <th className="pb-3 th-style">Reference</th>
                                                    <th className="pb-3 th-style">Credit</th>
                                                    <th className="pb-3 th-style">Debit</th>
                                                    <th className="pb-3 th-style">Closing</th>
                                                    <th className="pb-3 th-style">Payment Mode</th>
                                                    <th className="pb-3 th-style">Settlement Status</th>
                                                    <th className="pb-3 th-style">Settlement Amount</th>
                                                    <th className="pb-3 th-style">Category</th>
                                                    <th className="pb-3 th-style">Charges</th>
                                                    <th className="pb-3 th-style">Tax GST</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentEntries.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td className="pt-4 text-center">{item.datetime || "-"}</td>
                                                        <td className="pt-4 text-center">{item.customer_name || "-"}</td>
                                                        <td className="pt-4 text-center">{item.customer_mobile || "-"}</td>
                                                        <td className="pt-4 text-center">{item.refrence || "-"}</td>
                                                        <td className="pt-4 text-center">₹{parseFloat(item.credit || 0).toFixed(2)}</td>
                                                        <td className="pt-4 text-center">₹{parseFloat(item.debit || 0).toFixed(2)}</td>
                                                        <td className="pt-4 text-center">₹{parseFloat(item.closing || 0).toFixed(2)}</td>
                                                        <td className="pt-4 text-center">{item.payment_mode || "-"}</td>
                                                        <td className="pt-4 text-center"><StatusBadgeSettlement status={item.settlement_status} /></td>
                                                        <td className="pt-4 text-center">₹{parseFloat(item.settlement_amount || 0).toFixed(2)}</td>
                                                        <td className="pt-4 text-center"><CategoryBadge category={item.category} /></td>
                                                        <td className="pt-4 text-center">₹{parseFloat(item.charges || 0).toFixed(2)}</td>
                                                        <td className="pt-4 text-center">{item.tax_gst}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination */}
                                    {totalPages > 1 && (
                                        <div className="d-flex justify-content-center mt-4">
                                            <nav>
                                                <ul className="pagination">
                                                    {Array.from({ length: totalPages }, (_, i) => (
                                                        <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                                                            <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                                                                {i + 1}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </nav>
                                        </div>
                                    )}
                                </>
                            )}
                        </div></div>
                    <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0"><div className="mt-5">
                        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                            <h3 className="admin-settlement-heading mb-2">Processed Settlement History</h3>

                            <div className="d-flex gap-2 mb-2 ms-auto me-1 mt-1">
                                <input
                                    type="text"
                                    className="form-control form-sm"
                                    placeholder="Search history..."
                                    style={{ minWidth: "200px" }}
                                    value={searchQueryHistory}
                                    onChange={(e) => {
                                        setSearchQueryHistory(e.target.value);
                                        setCurrentPageHistory(1);
                                    }}
                                />
                            </div>
                            <button onClick={downloadHistoryExcel} className="btn btn-success">
                                <img src={Download} alt="" /> Download Excel
                            </button>
                        </div>

                        <div className="scrollable-table border-radius-10-left">
                            <table className="table table-bordered table-hover">
                                <thead className="text-center py-4">
                                    <tr className="text-center py-4">
                                        <th className="pb-3 th-style">ID</th>
                                        <th className="pb-3 th-style">Amount</th>
                                        <th className="pb-3 th-style">Order Amount</th>
                                        <th className="pb-3 th-style">Message Charges</th>
                                        <th className="pb-3 th-style">Platform Charge</th>
                                        <th className="pb-3 th-style">Delivery Charge</th>
                                        <th className="pb-3 th-style">Organization Name</th>
                                        <th className="pb-3 th-style">User Id</th>
                                        <th className="pb-3 th-style">To Date</th>
                                        <th className="pb-3 th-style">From Date</th>

                                        <th className="pb-3 th-style">Created On</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {currentEntriesHistory.map((item, id) => (
                                        <tr key={id}>
                                            <td className="pt-4 text-center">{item.id || "-"}</td>
                                            <td className="pt-4 text-center">{item.amount || "-"}</td>
                                            <td className="pt-4 text-center">{item.orderAmount || "-"}</td>
                                            <td className="pt-4 text-center">{item.messageCharges || "-"}</td>
                                            <td className="pt-4 text-center">{item.platformCharges || "-"}</td>
                                            <td className="pt-4 text-center">{item.deliveryCharges || "-"}</td>
                                            <td className="pt-4 text-center">{item.organization_name || "-"}</td>
                                            <td className="pt-4 text-center">{item.userid || "-"}</td>
                                            <td className="pt-4 text-center">{item.to_date || 0}</td>
                                            <td className="pt-4 text-center">{item.from_date || 0}</td>
                                            <td className="pt-4 text-center">{item.created_on || 0}</td>


                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        {totalPagesHistory > 1 && (
                            <div className="d-flex justify-content-center mt-4">
                                <nav>
                                    <ul className="pagination">
                                        {Array.from({ length: totalPagesHistory }, (_, i) => (
                                            <li key={i} className={`page-item ${currentPageHistory === i + 1 ? "active" : ""}`}>
                                                <button className="page-link" onClick={() => setCurrentPageHistory(i + 1)}>
                                                    {i + 1}
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                            </div>
                        )}
                    </div>
                    </div>
                    <div class="tab-pane fade" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab" tabindex="0">...</div>
                    <div class="tab-pane fade" id="disabled-tab-pane" role="tabpanel" aria-labelledby="disabled-tab" tabindex="0">...</div>
                </div>


            </div>
        </div>
    );
}

export default AdminSettlementAnalytics;
